import React from 'react';

/**
 * Badge visual para modalidade contratual do profissional (chapéu).
 * - "locacao"    → pill azul  com texto "LOC"
 * - "percentual" → pill roxo  com texto "%"
 * - null/undef   → não renderiza nada (profissional sem distinção)
 *
 * Uso: <ModalidadeBadge modalidade={profissional.modalidade_agenda} />
 * Tamanhos: size="sm" (default) | "xs" (para dropdowns compactos)
 */
export const ModalidadeBadge = ({ modalidade, size = 'sm', className = '' }) => {
  if (!modalidade) return null;

  const isLoc = modalidade === 'locacao';
  const label = isLoc ? 'LOC' : '%';
  const title = isLoc
    ? 'Modalidade: Locação (paga sala fixa)'
    : 'Modalidade: Percentual (repasse)';

  const styles = isLoc
    ? { backgroundColor: '#DBEAFE', color: '#1E40AF', borderColor: '#93C5FD' }
    : { backgroundColor: '#EDE9FE', color: '#6D28D9', borderColor: '#C4B5FD' };

  const sizeCls =
    size === 'xs'
      ? 'text-[10px] px-1.5 py-0 leading-4'
      : 'text-xs px-2 py-0.5 leading-none';

  return (
    <span
      title={title}
      data-testid={`modalidade-badge-${modalidade}`}
      className={`inline-flex items-center justify-center rounded-full border font-semibold ${sizeCls} ${className}`}
      style={styles}
    >
      {label}
    </span>
  );
};

export default ModalidadeBadge;
